import { render } from "./CreateIntegrationProductsResultModal.vue?vue&type=template&id=d3fba23c"
import script from "./CreateIntegrationProductsResultModal.vue?vue&type=script&lang=js"
export * from "./CreateIntegrationProductsResultModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__